import React from 'react';

/**
 * Circular icon-only button. Used for nav actions, panel close buttons,
 * and the message-bubble send control. Pass a Font Awesome <i> (or any
 * node) as children.
 */
export function IconButton({
  variant = 'glass',
  size = 'md',
  label,
  disabled = false,
  children,
  style = {},
  ...rest
}) {
  const [hover, setHover] = React.useState(false);

  const sizes = { sm: 32, md: 40, lg: 50 };
  const dim = sizes[size] || sizes.md;

  const palette = {
    glass: {
      background: hover ? 'rgba(0,0,0,0.5)' : 'rgba(0,0,0,0.3)',
      color: '#fff',
      border: '1px solid var(--border-on-dark)',
    },
    brand: {
      background: hover ? 'var(--brand-600)' : 'var(--brand-500)',
      color: '#fff',
      border: '1px solid transparent',
    },
    soft: {
      background: hover ? 'var(--brand-100)' : 'var(--brand-50)',
      color: 'var(--brand-600)',
      border: '1px solid transparent',
    },
    danger: {
      background: hover ? 'rgba(255,107,107,0.25)' : 'rgba(255,107,107,0.12)',
      color: 'var(--danger-400)',
      border: '1px solid transparent',
    },
  };
  const p = palette[variant] || palette.glass;

  return (
    <button
      aria-label={label}
      title={label}
      disabled={disabled}
      onMouseEnter={() => setHover(true)}
      onMouseLeave={() => setHover(false)}
      style={{
        width: dim,
        height: dim,
        padding: 0,
        display: 'inline-flex',
        alignItems: 'center',
        justifyContent: 'center',
        fontSize: dim * 0.42,
        background: p.background,
        color: p.color,
        border: p.border,
        borderRadius: 'var(--radius-pill)',
        backdropFilter: variant === 'glass' ? 'var(--blur-glass)' : 'none',
        cursor: disabled ? 'not-allowed' : 'pointer',
        opacity: disabled ? 0.5 : 1,
        transform: hover && !disabled ? 'scale(1.1)' : 'scale(1)',
        transition: 'transform var(--duration-fast) var(--ease-standard), background var(--duration-fast) var(--ease-standard)',
        ...style,
      }}
      {...rest}
    >
      {children}
    </button>
  );
}
